import { useEffect, useRef } from 'react';
import { trackPageView, AnalyticsEventData } from '../utils/analytics';

const usePageView = (eventName: string, data?: AnalyticsEventData): void => {
  const dataRef = useRef(data);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    trackPageView(eventName, dataRef.current);
  }, [eventName]);
};

export default usePageView;
